export const HOME = '/:clientCode/:airline';
export const SIGN_IN = 'sign-in';
export const CATERING_ROUTES = '';
